export function isNodes(representation) {
    return Array.isArray(representation);
}
export function isNode(representation) {
    return !isNodes(representation);
}
